<template>
	<v-dialog v-model="dialog" persistent max-width="80%" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-13 secondary--text">Pencarian Data</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			
			<v-card-text>
				<v-col class="px-0 mt-4 cl-secondary font-size-11 font-weight-500 border-grey">
					<v-card outlined elevation="0" class="mb-4">
						<v-card-text>
							<v-row>
								<v-col cols="12" sm="12" md="4">
									<v-text-field outlined dense hide-details="auto" prepend-inner-icon="mdi-barcode" label="Kode Serial" color="primary" v-model="params.serial_id.value"></v-text-field>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>

					<v-expansion-panels :accordion="true" :multiple="true">
						<v-expansion-panel class="mb-4" style="box-shadow: none;">
							<v-expansion-panel-header>
								<span class="d-flex align-center"><span class="mdi mdi-magnify mr-2" style="font-size: 20px;"></span> Pembelian Serial</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-divider></v-divider>
								<v-row>
									<v-col cols="12" sm="12" md="4">
										<v-menu v-model="searchDateBuy" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
											<template v-slot:activator="{ on, attrs }">
												<v-text-field outlined dense prepend-inner-icon="mdi-calendar" label="Tanggal Pembelian" readonly v-bind="attrs" v-on="on" :value="convertDate(params.buy_date.value)" hide-details="auto"></v-text-field>
											</template>
											<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="searchDateBuy = false" v-model="params.buy_date.value"></v-date-picker>
										</v-menu>
									</v-col>
									
									<v-col cols="12" sm="12" md="4">
										<v-text-field outlined dense hide-details="auto" label="Kode Mitra Pembeli" color="primary" v-model="params.buy_member_code.value"></v-text-field>
									</v-col>

									<v-col cols="12" sm="12" md="4">
										<v-text-field outlined dense hide-details="auto" label="Nama Mitra Pembeli" color="primary" v-model="params.buy_member_name.value"></v-text-field>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel class="mb-4">
							<v-expansion-panel-header>
								<span class="d-flex align-center"><span class="mdi mdi-magnify mr-2" style="font-size: 20px;"></span> Penggunaan Serial</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-divider></v-divider>
								<v-row>
									<v-col cols="12" sm="12" md="4">
										<v-menu v-model="searchDateUsed" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
											<template v-slot:activator="{ on, attrs }">
												<v-text-field outlined dense prepend-inner-icon="mdi-calendar" label="Tanggal Digunakan" readonly v-bind="attrs" v-on="on" :value="convertDate(params.used_date.value)" hide-details="auto"></v-text-field>
											</template>
											<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="searchDateUsed = false" v-model="params.used_date.value"></v-date-picker>
										</v-menu>
									</v-col>
									
									<v-col cols="12" sm="12" md="4">
										<v-text-field outlined dense hide-details="auto" label="Kode Mitra Pengguna" color="primary" v-model="params.used_member_code.value"></v-text-field>
									</v-col>

									<v-col cols="12" sm="12" md="4">
										<v-text-field outlined dense hide-details="auto" label="Nama Mitra Pengguna" color="primary" v-model="params.used_member_name.value"></v-text-field>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>

						<v-expansion-panel class="mb-4">
							<v-expansion-panel-header>
								<span class="d-flex align-center"><span class="mdi mdi-magnify mr-2" style="font-size: 20px;"></span> Aktivasi Serial</span>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-divider></v-divider>
								<v-row>
									<v-col cols="12" sm="12" md="4">
										<v-menu v-model="searchDateActivation" :close-on-content-click="false" :nudge-right="0" transition="scale-transition" offset-y min-width="290px">
											<template v-slot:activator="{ on, attrs }">
												<v-text-field outlined dense prepend-inner-icon="mdi-calendar" label="Tanggal Aktivasi" readonly v-bind="attrs" v-on="on" :value="convertDate(params.activation_date.value)" hide-details="auto"></v-text-field>
											</template>
											<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="searchDateActivation = false" v-model="params.activation_date.value"></v-date-picker>
										</v-menu>
									</v-col>
									
									<v-col cols="12" sm="12" md="4">
										<v-text-field outlined dense hide-details="auto" label="Kode Mitra Aktivasi" color="primary" v-model="params.activation_date.value"></v-text-field>
									</v-col>

									<v-col cols="12" sm="12" md="4">
										<v-text-field outlined dense hide-details="auto" label="Nama Mitra Aktivasi" color="primary" v-model="params.activation_date.value"></v-text-field>
									</v-col>
								</v-row>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>

				</v-col>
			</v-card-text>
			<v-card-actions class="justify-center">
				<v-col cols="4">
					<v-btn depressed block color="primary" class="white--text rounded-xl text-capitalize" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="cari">
						<v-icon small>mdi-magnify</v-icon>
						<span class="pl-2">Cari</span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
			searchDateBuy: false,
			searchDateUsed: false,
			searchDateActivation: false,
			btnLoadingProses: false,
			params: {
				serial_id: {
					type:'string',
					field:'serial_id',
					comparison: '=',
					value:''
				},

				buy_date: {
					type:'date',
					field:'serial_buy_datetime',
					comparison: '=',
					value:''
				},
				buy_member_code: {
					type:'string',
					field:'serial_buyer_network_code',
					comparison: '=',
					value:''
				},
				buy_member_name: {
					type:'string',
					field:'serial_buyer_network_name',
					comparison: '<>',
					value:''
				},
				
				used_date: {
					type:'date',
					field:'serial_used_datetime',
					comparison: '=',
					value:''
				},
				used_member_code: {
					type:'string',
					field:'serial_used_network_code',
					comparison: '=',
					value:''
				},
				used_member_name: {
					type:'string',
					field:'serial_used_member_name',
					comparison: '<>',
					value:''
				},

				activation_date: {
					type:'date',
					field:'serial_activation_datetime',
					comparison: '=',
					value:''
				},
				activation_member_code: {
					type:'string',
					field:'serial_activation_network_code',
					comparison: '=',
					value:''
				},
				activation_member_name: {
					type:'string',
					field:'serial_activation_member_name',
					comparison: '<>',
					value:''
				},
			},
		}
	},
	computed:{

	},
	props: {
		
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
			this.btnLoadingProses = false
		},
		reset() {
			this.params.serial_id.value = ''
			this.params.buy_date.value = ''
			this.params.buy_member_code.value = ''
			this.params.buy_member_name.value = ''

			this.params.used_date.value = ''
			this.params.used_member_code.value = ''
			this.params.used_member_name.value = ''

			this.params.activation_date.value = ''
			this.params.activation_member_code.value = ''
			this.params.activation_member_name.value = ''
		},
		async cari() {
			// if ( this.params.date.value || this.params.serial.value ) {
				this.btnLoadingProses = await true
				await this.$emit('action', this.params)
			// }
		},
	}
};
</script>